/* eslint-disable object-shorthand */

export const PACKAGE_BUILD_DATE = '2026-11-04T07:44:20.065Z';
export const PACKAGE_NAME = '@invision/authentication';
export const PACKAGE_VERSION = '5.0.0-2700249';

export default {
  PACKAGE_BUILD_DATE: PACKAGE_BUILD_DATE,
  PACKAGE_NAME: PACKAGE_NAME,
  PACKAGE_VERSION: PACKAGE_VERSION
};
